import { Paywall } from '/src/components/Paywall';

import UfoPNG from '@crazyegginc/hatch/dist/images/illustration-ufo-with-bg-and-objects.png';
import UfoWebP from '@crazyegginc/hatch/dist/images/illustration-ufo-with-bg-and-objects.webp';
import { AddSiteModal } from '/src/components/modals/AddSiteModal';
import { useAuthContext, useModal } from '/src/hooks';
import { ConfirmRedirectModal } from '../../google-analytics/modals/ConfirmRedirect';
import { ManageGaPropertiesModal } from '../../google-analytics/modals/ManageGaProperties';

export function NoSourcesWall() {
  const { currentAccount } = useAuthContext();
  const modal = useModal();

  return (
    <Paywall>
      <Paywall.Image webp={UfoWebP} fallback={UfoPNG} width="185px" className="!mt-0 !mb-[25px]" alt="UFO" />
      <Paywall.Title>Make sense of your Google Analytics data</Paywall.Title>
      <Paywall.Body>
        Connect GA4 to see traffic and audience insights clearly,
        <br />
        without digging through reports.
      </Paywall.Body>
      <div className="flex flex-col items-center space-y-1.5">
        <Paywall.Button
          className="!mb-0"
          onClick={() => {
            if ((currentAccount?.gaProperties ?? []).length > 0) {
              modal.show(<ManageGaPropertiesModal />);
            } else {
              modal.show(<ConfirmRedirectModal />);
            }
          }}
        >
          Connect Google Analytics
        </Paywall.Button>
        <button
          className="text-link !font-normal"
          onClick={() => {
            modal.show(<AddSiteModal />);
          }}
        >
          Or add Crazy Egg tracking
        </button>
      </div>
    </Paywall>
  );
}

NoSourcesWall.displayName = 'NoSourcesWall';
